import type { CustomMenu } from '../models/types'

import WhatToDoItem from './MenuItems/WhatToDoItem'
import WhatToSeeItem from './MenuItems/WhatToSeeItem'
import WhereToEatItem from './MenuItems/WhereToEatItem'
import WhereToSleepItem from './MenuItems/WhereToSleepItem'
import LocalProductsItem from './MenuItems/LocalProductsItem'
import ServicesItem from './MenuItems/ServicesItem'
import AgendaItem from './MenuItems/AgendaItem'

class FullMenu {
  menu: Array<CustomMenu> = []

  constructor(
    sendActivity,
    colors?: {
      whereToEatColor
      whereToSleepColor
      tobeSeenColor
      tobeDoneColor
      localProductsColor
      servicesColor
      agendaColor
      occupantColor
    }
  ) {
    this.menu.push(
      new WhatToDoItem(0, sendActivity, colors?.tobeDoneColor).getAsCustomMenu()
    )
    this.menu.push(
      new WhereToEatItem(
        1,
        sendActivity,
        colors?.whereToEatColor
      ).getAsCustomMenu()
    )
    this.menu.push(
      new WhereToSleepItem(
        2,
        sendActivity,
        colors?.whereToSleepColor
      ).getAsCustomMenu()
    )
    this.menu.push(
      new WhatToSeeItem(
        3,
        sendActivity,
        colors?.tobeSeenColor
      ).getAsCustomMenu()
    )
    this.menu.push(
      new LocalProductsItem(
        4,
        sendActivity,
        colors?.localProductsColor
      ).getAsCustomMenu()
    )
    this.menu.push(
      new ServicesItem(5, sendActivity, colors?.servicesColor).getAsCustomMenu()
    )
    this.menu.push(
      new AgendaItem(6, sendActivity, colors?.agendaColor).getAsCustomMenu()
    )
  }
}

export default FullMenu
